export class RuntimeInfo {
    constructor(
        public userId: string,
        public userDisplayName: string,
        public culture: string,
        public version: string,
        public canViewNotificationSummary: boolean,
        public csrfToken: string,
        public customControlInfo: RuntimeCustomControlInfo[],
        public preventControlsBoundToNonWritableFieldsPushingValues: boolean
    ) { }
}

export class RuntimeCustomControlInfo {
    constructor(
        public name: string,
        public module: string,
        public file: string,
        public dependencies: string[]
    ) { }
}